export default __webpack_public_path__ + "static/color-applying-color-2-light-4778b21e3721f45fe3a25e9768f3150b.png";